export const translations = {
  en: {
    nav: {
      licenseInfo: 'License Info',
      company: 'Company',
      activity: 'Activity',
      contact: 'Contact',
    },
    hero: {
      badge: 'Licensed & Certified',
      title: 'Crude Oil and Refined Oil Products Trading',
      description: 'QIUTOMS ENERGY FZ-LLC is a licensed Free Zone Limited Liability Company operating in Ras Al Khaimah Economic Zone, specializing in crude oil and refined oil products trading with full regulatory compliance and professional excellence.',
      viewLicense: 'View License Details',
      getInTouch: 'Get in Touch',
    },
    mission: {
      badge: 'Our Mission',
      title: 'Corporate Philosophy',
      subtitle: 'Our Mission and Goals',
      mainTitle: 'Contributing to Energy Security in Asia',
      mainDescription: 'With the cooperation of Arab countries, we are making every effort to secure energy for Asian countries, aiming to ensure energy security and stable supply.',
      card1Title: 'Cooperation with Arab Countries',
      card1Description: 'Building strong relationships with key partners in the Middle East region to establish a sustainable energy supply system',
      card2Title: 'Stable Energy Supply',
      card2Description: 'Supporting economic development through continuous and stable energy supply to the Asian region',
      card3Title: 'Contribution to Asian Markets',
      card3Description: 'Meeting the energy demands of Asian countries and contributing to sustainable regional growth',
      strategicTitle: 'Strategic Partnership',
      strategicDescription: 'Based on long-term trust relationships with the UAE and Arab countries, we are building an efficient energy supply network to Asian markets.',
      sustainableTitle: 'Sustainable Growth',
      sustainableDescription: 'Our mission is to support the economic development and sustainable industrial growth of the Asian region through energy security.',
    },
    license: {
      title: 'Commercial License Information',
      subtitle: 'Official registration and licensing details',
      licenseNumber: 'License Number',
      type: 'Type',
      licenseCode: 'License Code',
      issueDate: 'Issue Date',
      expiryDate: 'Expiry Date',
      status: 'Status',
      active: 'Active',
      freezone: 'Freezone',
      verificationTitle: 'Document Verification',
      verificationDescription: 'This document is electronically issued by Ras Al Khaimah Economic Zone Authority. Document Reference no.: 1659095-9eOG-gtTw-80562778. For verification purposes, please visit the official RAKEZ authentication portal.',
    },
    company: {
      title: 'Company Details',
      subtitle: 'Legal structure and business information',
      legalType: 'Legal Type',
      legalTypeValue: 'Free Zone Limited Liability Company FZ-LLC',
      legalTypeDescription: 'A limited liability company registered in the free zone jurisdiction',
      licensee: 'Licensee',
      licenseeDescription: 'Registered business entity name',
      operatingName: 'Operating Name',
      operatingNameDescription: 'Trading name for business operations',
      jurisdiction: 'Jurisdiction',
      jurisdictionValue: 'Ras Al Khaimah Economic Zone Authority',
      jurisdictionDescription: 'Regulatory authority and free zone operator',
      complianceTitle: 'Compliance & Regulations',
      complianceDescription: 'Issued by Ras Al Khaimah Economic Zone Authority and subject to all Laws, Regulations & Rules that belong to the authority. The company operates in full compliance with UAE federal and local regulations governing free zone entities.',
    },
    address: {
      title: 'Business Address',
      subtitle: 'Our registered office location',
      registeredAddress: 'Registered Address',
      building: 'Building',
      street: 'Street',
      zone: 'Zone',
      emirate: 'Emirate',
      email: 'Email',
    },
    activity: {
      title: 'Business Activity',
      subtitle: 'Our core operations and services',
      mainTitle: 'Crude Oil and Refined Oil Products Trading',
      mainDescription: 'QIUTOMS ENERGY FZ-LLC specializes in the trading of crude oil and refined oil products, operating within the regulatory framework of the Ras Al Khaimah Economic Zone. Our business activities are conducted in accordance with UAE federal and local regulations governing the petroleum and energy sector.',
      tradingTitle: 'Trading Operations',
      tradingDescription: 'Import and export of crude oil and refined petroleum products',
      supplyChainTitle: 'Supply Chain',
      supplyChainDescription: 'Efficient distribution and logistics management',
      qualityTitle: 'Quality Assurance',
      qualityDescription: 'Compliance with international quality standards',
      marketTitle: 'Market Expertise',
      marketDescription: 'Deep understanding of regional energy markets',
      compliance: 'Compliance',
      complianceDescription: 'Full regulatory compliance with UAE authorities',
      globalNetwork: 'Global Network',
      globalNetworkDescription: 'Strategic partnerships across international markets',
      excellence: 'Excellence',
      excellenceDescription: 'Commitment to operational excellence and quality',
    },
    manager: {
      title: 'Management',
      subtitle: 'Leadership and executive team',
      badge: 'Manager',
      name: 'ZHIFENG QIU',
      role: 'Company Manager',
      description: 'Leading QIUTOMS ENERGY FZ-LLC with strategic vision and operational excellence in the crude oil and refined oil products trading sector. Responsible for overall business operations, regulatory compliance, and strategic partnerships within the UAE and international markets.',
      leadershipTitle: 'Leadership Role',
      leadershipDescription: 'Oversees all business operations, strategic planning, and ensures compliance with regulatory requirements',
      teamTitle: 'Team Management',
      teamDescription: 'Leads and coordinates operational teams to achieve business objectives and maintain excellence',
      growthTitle: 'Strategic Growth',
      growthDescription: 'Drives business development initiatives and explores new market opportunities in the energy sector',
      complianceTitle: 'Compliance',
      complianceDescription: 'Ensures adherence to all regulatory requirements and maintains highest standards of corporate governance',
    },
    remarks: {
      title: 'Important Remarks',
      subtitle: 'Regulatory requirements and compliance notes',
      mainTitle: 'Regulatory Compliance Requirement',
      mainDescription: 'The Licensee must obtain the required approvals from the UAE Competent Government Authorities, as applicable.',
      keyPoints: 'Key Compliance Points:',
      point1: 'All business operations must comply with UAE federal and local regulations',
      point2: 'Required approvals must be obtained from relevant government authorities before commencing specific activities',
      point3: 'The company must maintain compliance with all laws, regulations, and rules of RAKEZ',
      point4: 'Regular renewal and updates of licenses and permits as required by regulatory authorities',
      governmentApprovals: 'Government Approvals',
      governmentApprovalsDescription: 'Required permits from UAE authorities',
      documentation: 'Documentation',
      documentationDescription: 'Maintain all required business documents',
      regularUpdates: 'Regular Updates',
      regularUpdatesDescription: 'Timely renewal of licenses and permits',
    },
    contact: {
      title: 'Ready to Connect?',
      description: 'For business inquiries and partnership opportunities, reach out to our team.',
      licenseNumber: 'License Number',
      type: 'Type',
    },
    footer: {
      description: 'Licensed Free Zone Limited Liability Company specializing in crude oil and refined oil products trading, operating under the regulatory framework of Ras Al Khaimah Economic Zone Authority.',
      quickLinks: 'Quick Links',
      mission: 'Corporate Philosophy',
      licenseInfo: 'License Info',
      companyDetails: 'Company Details',
      businessActivity: 'Business Activity',
      contact: 'Contact',
      contactInfo: 'Contact Info',
      copyright: '© 2026 QIUTOMS ENERGY FZ-LLC. All rights reserved.',
    },
  },
  ar: {
    nav: {
      licenseInfo: 'معلومات الترخيص',
      company: 'الشركة',
      activity: 'النشاط',
      contact: 'اتصل بنا',
    },
    hero: {
      badge: 'مرخص ومعتمد',
      title: 'تجارة النفط الخام والمنتجات النفطية المكررة',
      description: 'كيوتومز إنيرجي ش.ذ.م.م - منطقة حرة هي شركة ذات مسؤولية محدودة مرخصة تعمل في منطقة رأس الخيمة الاقتصادية، متخصصة في تجارة النفط الخام والمنتجات النفطية المكررة مع الامتثال التنظيمي الكامل والتميز المهني.',
      viewLicense: 'عرض تفاصيل الترخيص',
      getInTouch: 'تواصل معنا',
    },
    mission: {
      badge: 'مهمتنا',
      title: 'فلسفة الشركة',
      subtitle: 'مهمتنا وأهدافنا',
      mainTitle: 'المساهمة في أمن الطاقة في آسيا',
      mainDescription: 'بالتعاون مع الدول العربية، نبذل قصارى جهدنا لتأمين الطاقة للدول الآسيوية، بهدف ضمان أمن الطاقة والإمداد المستقر.',
      card1Title: 'التعاون مع الدول العربية',
      card1Description: 'بناء علاقات قوية مع الشركاء الرئيسيين في منطقة الشرق الأوسط لإنشاء نظام إمداد طاقة مستدام',
      card2Title: 'إمداد طاقة مستقر',
      card2Description: 'دعم التنمية الاقتصادية من خلال إمداد الطاقة المستمر والمستقر للمنطقة الآسيوية',
      card3Title: 'المساهمة في الأسواق الآسيوية',
      card3Description: 'تلبية متطلبات الطاقة للدول الآسيوية والمساهمة في النمو الإقليمي المستدام',
      strategicTitle: 'الشراكة الاستراتيجية',
      strategicDescription: 'بناءً على علاقات الثقة طويلة الأمد مع الإمارات والدول العربية، نقوم ببناء شبكة إمداد طاقة فعالة للأسواق الآسيوية.',
      sustainableTitle: 'النمو المستدام',
      sustainableDescription: 'مهمتنا هي دعم التنمية الاقتصادية والنمو الصناعي المستدام للمنطقة الآسيوية من خلال أمن الطاقة.',
    },
    license: {
      title: 'معلومات الترخيص التجاري',
      subtitle: 'تفاصيل التسجيل والترخيص الرسمية',
      licenseNumber: 'رقم الترخيص',
      type: 'النوع',
      licenseCode: 'رمز الترخيص',
      issueDate: 'تاريخ الإصدار',
      expiryDate: 'تاريخ الانتهاء',
      status: 'الحالة',
      active: 'نشط',
      freezone: 'منطقة حرة',
      verificationTitle: 'التحقق من المستند',
      verificationDescription: 'هذا المستند صادر إلكترونياً من هيئة مناطق رأس الخيمة الاقتصادية. رقم مرجع المستند: 1659095-9eOG-gtTw-80562778. لأغراض التحقق، يرجى زيارة بوابة التحقق الرسمية لراكز.',
    },
    company: {
      title: 'تفاصيل الشركة',
      subtitle: 'الهيكل القانوني ومعلومات الأعمال',
      legalType: 'النوع القانوني',
      legalTypeValue: 'شركة منطقة حرة ذات مسؤولية محدودة ش.ذ.م.م',
      legalTypeDescription: 'شركة ذات مسؤولية محدودة مسجلة في نطاق المنطقة الحرة',
      licensee: 'صاحب الترخيص',
      licenseeDescription: 'اسم الكيان التجاري المسجل',
      operatingName: 'الاسم التجاري',
      operatingNameDescription: 'الاسم التجاري للعمليات التجارية',
      jurisdiction: 'الاختصاص القضائي',
      jurisdictionValue: 'هيئة مناطق رأس الخيمة الاقتصادية',
      jurisdictionDescription: 'الهيئة التنظيمية ومشغل المنطقة الحرة',
      complianceTitle: 'الامتثال واللوائح',
      complianceDescription: 'صادر من هيئة مناطق رأس الخيمة الاقتصادية وخاضع لجميع القوانين واللوائح والقواعد التي تخصها. تعمل الشركة بامتثال كامل للوائح الاتحادية والمحلية الإماراتية التي تحكم كيانات المناطق الحرة.',
    },
    address: {
      title: 'عنوان العمل',
      subtitle: ' موقع مكتبنا المسجل',
      registeredAddress: 'العنوان المسجل',
      building: 'المبنى',
      street: 'الشارع',
      zone: 'المنطقة',
      emirate: 'الإمارة',
      email: 'البريد الإلكتروني',
    },
    activity: {
      title: 'النشاط التجاري',
      subtitle: 'عملياتنا وخدماتنا الأساسية',
      mainTitle: 'تجارة النفط الخام والمنتجات النفطية المكررة',
      mainDescription: 'تتخصص كيوتومز إنيرجي ش.ذ.م.م في تجارة النفط الخام والمنتجات النفطية المكررة، وتعامل ضمن الإطار التنظيمي لمنطقة رأس الخيمة الاقتصادية. تُجرى أنشطتنا التجارية وفقاً للوائح الاتحادية والمحلية الإماراتية التي تحكم قطاع البترول والطاقة.',
      tradingTitle: 'عمليات التداول',
      tradingDescription: 'استيراد وتصدير النفط الخام والمنتجات البترولية المكررة',
      supplyChainTitle: 'سلسلة التوريد',
      supplyChainDescription: 'إدارة التوزيع واللوجستيات بكفاءة',
      qualityTitle: 'ضمان الجودة',
      qualityDescription: 'الامتثال لمعايير الجودة الدولية',
      marketTitle: 'خبرة السوق',
      marketDescription: 'فهم عميق لأسواق الطاقة الإقليمية',
      compliance: 'الامتثال',
      complianceDescription: 'الامتثال التنظيمي الكامل مع السلطات الإماراتية',
      globalNetwork: 'الشبكة العالمية',
      globalNetworkDescription: 'شراكات استراتيجية عبر الأسواق الدولية',
      excellence: 'التميز',
      excellenceDescription: 'الالتزام بالتميز التشغيلي والجودة',
    },
    manager: {
      title: 'الإدارة',
      subtitle: 'القيادة والفريق التنفيذي',
      badge: 'المدير',
      name: 'تشيفنغ تشيو',
      role: 'مدير الشركة',
      description: 'يقود كيوتومز إنيرجي ش.ذ.م.م برؤية استراتيجية وتميز تشغيلي في قطاع تجارة النفط الخام والمنتجات النفطية المكررة. مسؤول عن العمليات التجارية الشاملة والامتثال التنظيمي والشراكات الاستراتيجية داخل الإمارات والأسواق الدولية.',
      leadershipTitle: 'الدور القيادي',
      leadershipDescription: 'يشرف على جميع العمليات التجارية والتخطيط الاستراتيجي ويضمن الامتثال للمتطلبات التنظيمية',
      teamTitle: 'إدارة الفريق',
      teamDescription: 'يقود وينسق الفرق التشغيلية لتحقيق أهداف العمل والحفاظ على التميز',
      growthTitle: 'النمو الاستراتيجي',
      growthDescription: 'يدفع مبادرات تطوير الأعمال ويستكشف فرص السوق الجديدة في قطاع الطاقة',
      complianceTitle: 'الامتثال',
      complianceDescription: 'يضمن الالتزام بجميع المتطلبات التنظيمية ويحافظ على أعلى معايير حوكمة الشركات',
    },
    remarks: {
      title: 'ملاحظات مهمة',
      subtitle: 'متطلبات الامتثال وملاحظات الامتثال',
      mainTitle: 'متطلبات الامتثال التنظيمي',
      mainDescription: 'يجب على صاحب الترخيص الحصول على الموافقات المطلوبة من الجهات الحكومية المختصة في الإمارات، حسب الاقتراض.',
      keyPoints: 'نقاط الامتثال الرئيسية:',
      point1: 'يجب أن تمتثل جميع العمليات التجارية للوائح الاتحادية والمحلية الإماراتية',
      point2: 'يجب الحصول على الموافقات المطلوبة من الجهات الحكومية ذات الصلة قبل البدء في أنشطة محددة',
      point3: 'يجب على الشركة الحفاظ على الامتثال لجميع قوانين ولوائح وقواعد راكز',
      point4: 'التجديد والتحديث المنتظم للتراخيص والتصاريح كما هو مطلوب من الجهات التنظيمية',
      governmentApprovals: 'الموافقات الحكومية',
      governmentApprovalsDescription: 'التصاريح المطلوبة من السلطات الإماراتية',
      documentation: 'التوثيق',
      documentationDescription: 'الحفاظ على جميع مستندات العمل المطلوبة',
      regularUpdates: 'التحديثات المنتظمة',
      regularUpdatesDescription: 'تجديد التراخيص والتصاريح في الوقت المناسب',
    },
    contact: {
      title: 'مستعد للتواصل؟',
      description: 'للاستفسارات التجارية وفرص الشراكة، تواصل مع فريقنا.',
      licenseNumber: 'رقم الترخيص',
      type: 'النوع',
    },
    footer: {
      description: 'شركة منطقة حرة ذات مسؤولية محدودة مرخصة متخصصة في تجارة النفط الخام والمنتجات النفطية المكررة، تعمل تحت الإطار التنظيمي لهيئة مناطق رأس الخيمة الاقتصادية.',
      quickLinks: 'روابط سريعة',
      mission: 'فلسفة الشركة',
      licenseInfo: 'معلومات الترخيص',
      companyDetails: 'تفاصيل الشركة',
      businessActivity: 'النشاط التجاري',
      contact: 'اتصل بنا',
      contactInfo: 'معلومات الاتصال',
      copyright: '© 2026 كيوتومز إنيرجي ش.ذ.م.م. جميع الحقوق محفوظة.',
    },
  },
  zh: {
    nav: {
      licenseInfo: '许可证信息',
      company: '公司',
      activity: '业务',
      contact: '联系我们',
    },
    hero: {
      badge: '持证经营',
      title: '原油及精炼石油产品贸易',
      description: 'QIUTOMS ENERGY FZ-LLC是一家在拉斯海马经济区运营的持牌自由区有限责任公司，专门从事原油及精炼石油产品贸易，完全符合监管要求，追求专业卓越。',
      viewLicense: '查看许可证详情',
      getInTouch: '联系我们',
    },
    mission: {
      badge: '我们的使命',
      title: '企业理念',
      subtitle: '我们的使命与目标',
      mainTitle: '为亚洲能源安全做出贡献',
      mainDescription: '在阿拉伯国家的合作下，我们正在尽最大努力为亚洲国家确保能源供应，旨在保障能源安全和稳定供应。',
      card1Title: '与阿拉伯国家合作',
      card1Description: '与中东地区的主要合作伙伴建立牢固关系，建立可持续的能源供应体系',
      card2Title: '稳定能源供应',
      card2Description: '通过向亚洲地区持续稳定地供应能源，支持经济发展',
      card3Title: '贡献亚洲市场',
      card3Description: '满足亚洲国家的能源需求，为区域可持续增长做出贡献',
      strategicTitle: '战略合作伙伴关系',
      strategicDescription: '基于与阿联酋和阿拉伯国家的长期信任关系，我们正在建立面向亚洲市场的高效能源供应网络。',
      sustainableTitle: '可持续增长',
      sustainableDescription: '我们的使命是通过能源安全支持亚洲地区的经济发展和可持续工业增长。',
    },
    license: {
      title: '商业许可证信息',
      subtitle: '官方注册和许可详情',
      licenseNumber: '许可证号',
      type: '类型',
      licenseCode: '许可证代码',
      issueDate: '签发日期',
      expiryDate: '到期日期',
      status: '状态',
      active: '有效',
      freezone: '自由区',
      verificationTitle: '文件验证',
      verificationDescription: '本文件由拉斯海马经济区管理局电子签发。文件参考号：1659095-9eOG-gtTw-80562778。如需验证，请访问RAKEZ官方认证门户。',
    },
    company: {
      title: '公司详情',
      subtitle: '法律结构和业务信息',
      legalType: '法律类型',
      legalTypeValue: '自由区有限责任公司 FZ-LLC',
      legalTypeDescription: '在自由区管辖范围内注册的有限责任公司',
      licensee: '被许可人',
      licenseeDescription: '注册商业实体名称',
      operatingName: '经营名称',
      operatingNameDescription: '商业运营的贸易名称',
      jurisdiction: '管辖区',
      jurisdictionValue: '拉斯海马经济区管理局',
      jurisdictionDescription: '监管机构和自由区运营商',
      complianceTitle: '合规与法规',
      complianceDescription: '由拉斯海马经济区管理局签发，受该管理局所有法律、法规和规则的约束。公司完全遵守管理自由区实体的阿联酋联邦和地方法规。',
    },
    address: {
      title: '营业地址',
      subtitle: '我们的注册办公地点',
      registeredAddress: '注册地址',
      building: '大楼',
      street: '街道',
      zone: '区域',
      emirate: '酋长国',
      email: '电子邮件',
    },
    activity: {
      title: '业务活动',
      subtitle: '我们的核心运营和服务',
      mainTitle: '原油及精炼石油产品贸易',
      mainDescription: 'QIUTOMS ENERGY FZ-LLC专门从事原油及精炼石油产品贸易，在拉斯海马经济区的监管框架内运营。我们的业务活动符合管理石油和能源行业的阿联酋联邦和地方法规。',
      tradingTitle: '贸易运营',
      tradingDescription: '原油及精炼石油产品的进出口',
      supplyChainTitle: '供应链',
      supplyChainDescription: '高效的分销和物流管理',
      qualityTitle: '质量保证',
      qualityDescription: '符合国际质量标准',
      marketTitle: '市场专业知识',
      marketDescription: '深入了解区域能源市场',
      compliance: '合规',
      complianceDescription: '完全符合阿联酋当局的监管要求',
      globalNetwork: '全球网络',
      globalNetworkDescription: '跨国际市场的战略合作伙伴关系',
      excellence: '卓越',
      excellenceDescription: '致力于运营卓越和质量',
    },
    manager: {
      title: '管理层',
      subtitle: '领导和执行团队',
      badge: '经理',
      name: '邱之峰',
      role: '公司经理',
      description: '以战略眼光和卓越运营领导QIUTOMS ENERGY FZ-LLC在原油及精炼石油产品贸易领域的发展。负责整体业务运营、监管合规以及阿联酋和国际市场的战略合作伙伴关系。',
      leadershipTitle: '领导角色',
      leadershipDescription: '监督所有业务运营、战略规划,并确保符合监管要求',
      teamTitle: '团队管理',
      teamDescription: '领导和协调运营团队以实现业务目标并保持卓越',
      growthTitle: '战略增长',
      growthDescription: '推动业务发展计划并探索能源行业的新市场机会',
      complianceTitle: '合规',
      complianceDescription: '确保遵守所有监管要求并保持最高标准的公司治理',
    },
    remarks: {
      title: '重要备注',
      subtitle: '监管要求和合规说明',
      mainTitle: '监管合规要求',
      mainDescription: '被许可人必须根据适用情况从阿联酋主管政府部门获得所需批准。',
      keyPoints: '关键合规要点：',
      point1: '所有业务运营必须符合阿联酋联邦和地方法规',
      point2: '在开始特定活动之前，必须从相关政府部门获得所需批准',
      point3: '公司必须遵守RAKEZ的所有法律、法规和规则',
      point4: '根据监管机构的要求定期更新和续签许可证和许可',
      governmentApprovals: '政府批准',
      governmentApprovalsDescription: '阿联酋当局要求的许可',
      documentation: '文件',
      documentationDescription: '保存所有必需的业务文件',
      regularUpdates: '定期更新',
      regularUpdatesDescription: '及时续签许可证和许可',
    },
    contact: {
      title: '准备好联系了吗？',
      description: '如有业务咨询和合作机会，请联系我们的团队。',
      licenseNumber: '许可证号',
      type: '类型',
    },
    footer: {
      description: '持牌自由区有限责任公司，专门从事原油及精炼石油产品贸易，在拉斯海马经济区管理局的监管框架下运营。',
      quickLinks: '快速链接',
      mission: '企业理念',
      licenseInfo: '许可证信息',
      companyDetails: '公司详情',
      businessActivity: '业务活动',
      contact: '联系我们',
      contactInfo: '联系信息',
      copyright: '© 2026 QIUTOMS ENERGY FZ-LLC。保留所有权利。',
    },
  },
  ja: {
    nav: {
      licenseInfo: 'ライセンス情報',
      company: '会社概要',
      activity: '事業内容',
      contact: 'お問い合わせ',
    },
    hero: {
      badge: '認可・認証済み',
      title: '原油および精製石油製品取引',
      description: 'QIUTOMS ENERGY FZ-LLCは、ラス・アル・ハイマ経済特区で事業を展開する認可済みフリーゾーン有限責任会社であり、完全な規制遵守と専門的な卓越性をもって原油および精製石油製品取引を専門としています。',
      viewLicense: 'ライセンス詳細を見る',
      getInTouch: 'お問い合わせ',
    },
    mission: {
      badge: '私たちの使命',
      title: '企業理念',
      subtitle: '私たちの使命と目標',
      mainTitle: 'アジアのエネルギー安全保障への貢献',
      mainDescription: 'アラブ諸国の協力を得ながら、エネルギーの確保と安定供給を目的として、アジア諸国のエネルギー確保に向けて最大限の努力を行っています。',
      card1Title: 'アラブ諸国との協力',
      card1Description: '中東地域の主要パートナーとの強固な関係を構築し、持続可能なエネルギー供給システムを確立',
      card2Title: '安定したエネルギー供給',
      card2Description: 'アジア地域への継続的かつ安定したエネルギー供給を通じて経済発展を支援',
      card3Title: 'アジア市場への貢献',
      card3Description: 'アジア諸国のエネルギー需要に応え、持続可能な地域成長に貢献',
      strategicTitle: '戦略的パートナーシップ',
      strategicDescription: 'UAEおよびアラブ諸国との長期的な信頼関係に基づき、アジア市場への効率的なエネルギー供給ネットワークを構築しています。',
      sustainableTitle: '持続可能な成長',
      sustainableDescription: '私たちの使命は、エネルギー安全保障を通じてAsia地域の経済発展と持続可能な産業成長を支援することです。',
    },
    license: {
      title: '商業ライセンス情報',
      subtitle: '公式登録およびライセンスの詳細',
      licenseNumber: 'ライセンス番号',
      type: '種類',
      licenseCode: 'ライセンスコード',
      issueDate: '発行日',
      expiryDate: '有効期限',
      status: 'ステータス',
      active: '有効',
      freezone: 'フリーゾーン',
      verificationTitle: '文書認証',
      verificationDescription: 'この文書はラス・アル・ハイマ経済特区当局により電子発行されています。文書参照番号：1659095-9eOG-gtTw-80562778。認証については、RAKEZ公式認証ポータルをご覧ください。',
    },
    company: {
      title: '会社概要',
      subtitle: '法的構造と事業情報',
      legalType: '法人形態',
      legalTypeValue: 'フリーゾーン有限責任会社 FZ-LLC',
      legalTypeDescription: 'フリーゾーン管轄区域に登録された有限責任会社',
      licensee: 'ライセンシー',
      licenseeDescription: '登録事業体名',
      operatingName: '商号',
      operatingNameDescription: '事業運営のための商号',
      jurisdiction: '管轄区域',
      jurisdictionValue: 'ラス・アル・ハイマ経済特区当局',
      jurisdictionDescription: '規制当局およびフリーゾーン運営者',
      complianceTitle: 'コンプライアンスと規制',
      complianceDescription: 'ラス・アル・ハイマ経済特区当局により発行され、当局に属するすべての法律、規制、規則に従います。当社はフリーゾーン事業体を管理するUAE連邦および地方規制に完全に準拠して運営しています。',
    },
    address: {
      title: '事業所住所',
      subtitle: '登記上の事務所所在地',
      registeredAddress: '登記住所',
      building: 'ビル',
      street: '通り',
      zone: 'ゾーン',
      emirate: '首長国',
      email: 'メールアドレス',
    },
    activity: {
      title: '事業内容',
      subtitle: '当社の主要事業とサービス',
      mainTitle: '原油および精製石油製品取引',
      mainDescription: 'QIUTOMS ENERGY FZ-LLCは、ラス・アル・ハイマ経済特区の規制枠組み内で原油および精製石油製品の取引を専門としています。当社の事業活動は、石油・エネルギー部門を管理するUAE連邦および地方規制に従って行われています。',
      tradingTitle: '取引業務',
      tradingDescription: '原油および精製石油製品の輸出入',
      supplyChainTitle: 'サプライチェーン',
      supplyChainDescription: '効率的な流通・物流管理',
      qualityTitle: '品質保証',
      qualityDescription: '国際品質基準への準拠',
      marketTitle: '市場専門知識',
      marketDescription: '地域エネルギー市場への深い理解',
      compliance: 'コンプライアンス',
      complianceDescription: 'UAE当局への完全な規制遵守',
      globalNetwork: 'グローバルネットワーク',
      globalNetworkDescription: '国際市場における戦略的パートナーシップ',
      excellence: '卓越性',
      excellenceDescription: '運営の卓越性と品質へのコミットメント',
    },
    manager: {
      title: '経営陣',
      subtitle: 'リーダーシップと経営チーム',
      badge: 'マネージャー',
      name: '邱之峰',
      role: '会社マネージャー',
      description: '原油および精製石油製品取引部門において、戦略的ビジョンと運営の卓越性をもってQIUTOMS ENERGY FZ-LLCを率いています。UAE内および国際市場における全体的な事業運営、規制遵守、戦略的パートナーシップを担当しています。',
      leadershipTitle: 'リーダーシップの役割',
      leadershipDescription: 'すべての事業運営、戦略計画を監督し、規制要件への準拠を確保',
      teamTitle: 'チーム管理',
      teamDescription: '事業目標を達成し卓越性を維持するために運営チームを率い調整',
      growthTitle: '戦略的成長',
      growthDescription: '事業開発イニシアチブを推進し、エネルギー部門の新しい市場機会を探索',
      complianceTitle: 'コンプライアンス',
      complianceDescription: 'すべての規制要件への準拠を確保し、最高水準のコーポレートガバナンスを維持',
    },
    remarks: {
      title: '重要な備考',
      subtitle: '規制要件とコンプライアンスに関する注記',
      mainTitle: '規制遵守要件',
      mainDescription: 'ライセンシーは、該当する場合、UAE管轄政府当局から必要な承認を取得する必要があります。',
      keyPoints: '主要なコンプライアンスポイント：',
      point1: 'すべての事業運営はUAE連邦および地方規制に準拠する必要があります',
      point2: '特定の活動を開始する前に、関連する政府当局から必要な承認を取得する必要があります',
      point3: '会社はRAKEZのすべての法律、規制、規則への準拠を維持する必要があります',
      point4: '規制当局の要求に応じて、ライセンスと許可の定期的な更新と更新',
      governmentApprovals: '政府承認',
      governmentApprovalsDescription: 'UAE当局からの必要な許可',
      documentation: '文書',
      documentationDescription: '必要なすべての事業文書を維持',
      regularUpdates: '定期更新',
      regularUpdatesDescription: 'ライセンスと許可のタイムリーな更新',
    },
    contact: {
      title: 'お問い合わせの準備はできましたか？',
      description: 'ビジネスに関するお問い合わせやパートナーシップの機会については、当社チームにご連絡ください。',
      licenseNumber: 'ライセンス番号',
      type: '種類',
    },
    footer: {
      description: 'ラス・アル・ハイマ経済特区当局の規制枠組みの下で運営される、原油および精製石油製品取引を専門とする認可済みフリーゾーン有限責任会社。',
      quickLinks: 'クイックリンク',
      mission: '企業理念',
      licenseInfo: 'ライセンス情報',
      companyDetails: '会社概要',
      businessActivity: '事業内容',
      contact: 'お問い合わせ',
      contactInfo: '連絡先情報',
      copyright: '© 2026 QIUTOMS ENERGY FZ-LLC. All rights reserved.',
    },
  },
};
